
import { useState } from 'react';
import { Provider } from 'react-redux';
import './App.css';
import AddBookForm from './components/AddBookForm';
import BookList from './components/BookList';
import Navbar from './components/Navbar';
import store from './redux/store';

function App() {

  const [bookInputs,setbookInputs]=useState({
    name:"",
    author:"",
    thumbnail:"",
    price:0,
    rating:0,
    featured:false
});
const[keyWord,setKeyWord]=useState(""); 

const[isUpdate,setIsUpdate]=useState(false)

  return (
    <>
       <Provider store={store}>

     
     <div>
  <Navbar   setKeyWord={setKeyWord}    />
  <main className="py-12 2xl:px-6">
    <div className="container grid xl:grid-cols-[auto_350px] 2xl:grid-cols-[auto_400px] gap-4 2xl:gap-8">

     <BookList keyWord={keyWord} isUpdate={isUpdate} setIsUpdate={setIsUpdate}  setbookInputs={setbookInputs} />
   
       
       <AddBookForm  isUpdate={isUpdate} setIsUpdate={setIsUpdate}  bookInputs={bookInputs} setbookInputs={setbookInputs}/>
     
    </div>
  </main>
</div>
</Provider>
    </>
  );
}

export default App;
